enum FormFields {
  Name = 'name',
  InventoryType = 'inventoryType',
  Type = 'type',
  Bedrooms = 'averageBedroomsNumber',
  Bathrooms = 'averageBathroomsNumber',
  TotalSqft = 'averageTotalSqft',
  InteriorSqft = 'averageInteriorSqft',
  ExteriorSqft = 'averageExteriorSqft',
  Prices = 'prices',
  FloorPlanFile = 'floorPlanFile',
  FloorPlanFileId = 'floorPlanFileId',
  FloorPlanLoading = 'floorPlanLoading',
  CustomRooms = 'customRooms',
}

const FormFieldsList = [
  FormFields.Name,
  FormFields.InventoryType,
  FormFields.Bedrooms,
  FormFields.Bathrooms,
  FormFields.TotalSqft,
  FormFields.InteriorSqft,
  FormFields.ExteriorSqft,
  FormFields.Prices,
  FormFields.FloorPlanFile,
  FormFields.FloorPlanFileId,
  FormFields.FloorPlanLoading,
  FormFields.CustomRooms,
];

export { FormFields, FormFieldsList };
